<template>
  <div id="analyze">
    <transition mode="out-in">
      <div v-if="game.isProMode" key="'pro'">
        <AnalyzeDetail />
      </div>
      <div v-else key="'normal'">
        <AnalyzeNormal />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AnalyzeNormal from '@/components/organisms/AnalyzeNormal';
import AnalyzeDetail from '@/components/organisms/AnalyzeDetail';

export default {
  name: 'analyze',
  components: {
    AnalyzeDetail,
    AnalyzeNormal,
  },
  mounted() {
    // 他のユーザーのデータをstoreに配置している場合、リセットする
    if (this.game.author && this.user.uid) {
      if (this.game.author !== this.user.uid) {
        this.reset({ isProMode: false });
      }
    } else if (this.game.author && !this.user.uid) {
      this.reset({ isProMode: false });
    }
  },
  computed: {
    ...mapGetters([
      'game',
      'user',
    ]),
  },
  methods: {
    ...mapActions([
      'reset',
    ]),
  },
};
</script>

<style scoped>
.v-enter-active, .v-leave-active {
  transition: opacity .2s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/views/Analyze.vue